import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  searchTermTabLoader: false,
  isSearchTermTabDataFetched: false,

  //===== Search Terms with Performance, Without Classification =====//
  selectedSearchTermForUnclassifiedST: "", // single selected search term (Search Terms with Performance, Without Classification)
  selectedCampaignForUnclassifiedST: [], // filtered campaign (Search Terms with Performance, Without Classification)
  selectedAdGroupForUnclassifiedST: [], // filtered ad group (Search Terms with Performance, Without Classification)
  selectedKeywordForUnclassifiedST: [], // filtered keyword (Search Terms with Performance, Without Classification)
  stWithPerformanceUnClassified: [], // Search Terms with performance without classification data

  selectedRowsForUnclassifiedST: [], // selected rows in the table (Search Terms with Performance, Without Classification)
  selectedDefinitionsForUnclassifiedST: {}, // selected definitions for each row
  isDefinitionModalOpenForUnclassifiedST: false,
  definitionModalSourceForUnclassifiedST: "", // To track modal source (headerIcon or saveButton) for unclassified ST
  definitionModalTypeForUnclassifiedST: "", // To track modal type (Exclusive, Allowed, Negative) for unclassified ST
  isOpenOtherKeywordDialogSTOUnclassified: false, // Other Keyword Dialog open state for unclassified ST
  otherKeywordsForUnclassifiedST: [], // To store other keywords Modal data for unclassified ST
  otherKeywordRelatedToSearchTerm: "", // To store the search term related to other keywords modal for unclassified ST

  //===== Search Terms Missing Cross Negatives =====//
  selectedSearchTermForMissingCrossNegatives: "", // single selected search term (Missing Cross Negatives)
  selectedCampaignForMissingCrossNegatives: [], // filtered campaign (Missing Cross Negatives)
  selectedAdGroupForMissingCrossNegatives: [], // filtered ad group (Missing Cross Negatives)
  selectedKeywordForMissingCrossNegatives: [], // filtered keyword (Missing Cross Negatives)
  stMissingCrossNegatives: [], // Search Terms Missing Cross Negatives

  selectedRowsForMissingCrossNegatives: [], // selected rows in the table (Missing Cross Negatives)
  toggledNegativesForMissingCrossNegatives: [], // toggled negative definitions for each row

  isOpenModalOfOtherNonNegativeAdgroups: false, // Other Non-Negative Adgroups Modal open state for Missing Cross Negatives
  otherNonNegativeAdgroupsForMissingCrossNegatives: [], // To store other non-negative adgroups Modal data for Missing Cross Negatives

  isDefinitionModalOpenForMissingCrossNegatives: false,
  definitionModalSourceForMissingCrossNegatives: "", // To track modal source (headerIcon or saveButton) for Missing Cross Negatives

  //===== Contradicting ST Definition =====//
  selectedSearchTermForContradictingSTDefinition: "", // single selected search term (Contradicting ST Definition)
  selectedCampaignForContradictingSTDefinition: [], // filtered campaign (Contradicting ST Definition)
  selectedAdGroupForContradictingSTDefinition: [], // filtered ad group (Contradicting ST Definition)
  selectedKeywordForContradictingSTDefinition: [], // filtered keyword (Contradicting ST Definition)
  contradictingSTDefinition: [], // Search Terms - Contradicting ST Definition

  selectedRowsForContradictingSTDefinition: [], // selected rows in the table (Contradicting ST Definition)
  toggledNegativesForContradictingSTDefinition: [], // toggled negative definitions for each row
  isDefinitionModalOpenForContradictingST: false, // Definition modal open state for Contradicting ST
  definitionModalSourceForContradictingST: "", // To track modal source (headerIcon or saveButton) for Contradicting ST
  confirmLoaderForContradictingSTDefinition: false, // confirm loader for Contradicting ST(when user clicks on confirm in modals)

  //===== Search Terms Identical To Exact Keyword =====//
  selectedSearchTermForIdenticalToExactKeyword: "", // single selected search term (Identical To Exact Keyword)
  selectedCampaignForIdenticalToExactKeyword: [], // filtered campaign (Identical To Exact Keyword)
  selectedAdGroupForIdenticalToExactKeyword: [], // filtered ad group (Identical To Exact Keyword)
  selectedKeywordForIdenticalToExactKeyword: [], // filtered keyword (Identical To Exact Keyword)
  stIdenticalToExactKeyword: [], // Search Terms Identical To Exact Keyword
  selectedRowsForIdenticalToExactKeyword: [], // selected rows in the table (Identical To Exact Keyword)
  toggledNegativesForIdenticalToExactKeyword: [], // toggled negative definitions for each row

  isOpenModalOfAdgroupsForIdenticalToExactKeyword: false, // Other Non-Negative Adgroups Modal open state for Identical To Exact Keyword
  otherNonNegativeAdgroupsForIdenticalToExactKeyword: [], // To store other non-negative adgroups Modal data for Identical To Exact Keyword

  isDefinitionModalOpenForIdenticalToExactKeyword: false,
  definitionModalSourceForIdenticalToExactKeyword: "", // To track modal source (headerIcon or saveButton) for Identical To Exact Keyword

  //===== Search Terms Captured By Multiple Keywords =====//
  selectedSearchTermForCapturedByMultipleKeywords: "", // single selected search term
  selectedCampaignForCapturedByMultipleKeywords: [], // filtered campaign
  selectedAdGroupForCapturedByMultipleKeywords: [], // filtered ad group
  selectedKeywordForCapturedByMultipleKeywords: [], // filtered keyword

  capturedByMultipleKeywords: [], // Search Terms captured by multiple keywords

  selectedRowsForCapturedByMultipleKeywords: [], // selected rows in the table
  selectedDefinitionsForCapturedByMultipleKeywords: {}, // selected definitions for each row

  isDefinitionModalOpenForCapturedByMultipleKeywords: false,
  definitionModalSourceForCapturedByMultipleKeywords: "", // headerIcon | saveButton
  definitionModalTypeForCapturedByMultipleKeywords: "", // Exclusive | Allowed | Negative

  isOpenOtherKeywordDialogForCapturedByMultipleKeywords: false, // Other Keyword dialog open state
  otherKeywordsForCapturedByMultipleKeywords: [], // other keywords modal data

  //===== Common ST Control =====//
  confirmLoaderSTControl: false, // confirm loader for all ST control(when user clicks on confirm in modals)
};

const searchTermTabSlice = createSlice({
  name: "searchTermTab",
  initialState,
  reducers: {
    setSelectedSearchTermForUnclassifiedST: (state, action) => {
      state.selectedSearchTermForUnclassifiedST = action.payload;
    },
    setSelectedCampaignForUnclassifiedST: (state, action) => {
      state.selectedCampaignForUnclassifiedST = action.payload;
    },
    setSelectedAdGroupForUnclassifiedST: (state, action) => {
      state.selectedAdGroupForUnclassifiedST = action.payload;
    },
    setSelectedKeywordForUnclassifiedST: (state, action) => {
      state.selectedKeywordForUnclassifiedST = action.payload;
    },
    setSTWithPerformanceUnClassified: (state, action) => {
      state.stWithPerformanceUnClassified = action.payload;
    },
    setSearchTermTabLoader: (state, action) => {
      state.searchTermTabLoader = action.payload;
    },
    setIsSearchTermTabDataFetched: (state, action) => {
      state.isSearchTermTabDataFetched = action.payload;
    },
    setSelectedRowsForUnclassifiedST: (state, action) => {
      state.selectedRowsForUnclassifiedST = action.payload;
    },
    setSelectedDefinitionsForUnclassifiedST: (state, action) => {
      state.selectedDefinitionsForUnclassifiedST = action.payload;
    },
    setIsDefinitionModalOpenForUnclassifiedST: (state, action) => {
      state.isDefinitionModalOpenForUnclassifiedST = action.payload;
    },
    setDefinitionModalSourceForUnclassifiedST: (state, action) => {
      state.definitionModalSourceForUnclassifiedST = action.payload;
    },
    setDefinitionModalTypeForUnclassifiedST: (state, action) => {
      state.definitionModalTypeForUnclassifiedST = action.payload;
    },
    setIsOpenOtherKeywordDialogSTOUnclassified: (state, action) => {
      state.isOpenOtherKeywordDialogSTOUnclassified = action.payload;
    },
    setOtherKeywordsForUnclassifiedST: (state, action) => {
      state.otherKeywordsForUnclassifiedST = action.payload;
    },
    setOtherKeywordRelatedToSearchTerm: (state, action) => {
      state.otherKeywordRelatedToSearchTerm = action.payload;
    },
    setConfirmLoaderSTControl: (state, action) => {
      state.confirmLoaderSTControl = action.payload;
    },

    setSelectedSearchTermForMissingCrossNegatives: (state, action) => {
      state.selectedSearchTermForMissingCrossNegatives = action.payload;
    },
    setSelectedCampaignForMissingCrossNegatives: (state, action) => {
      state.selectedCampaignForMissingCrossNegatives = action.payload;
    },
    setSelectedAdGroupForMissingCrossNegatives: (state, action) => {
      state.selectedAdGroupForMissingCrossNegatives = action.payload;
    },
    setSelectedKeywordForMissingCrossNegatives: (state, action) => {
      state.selectedKeywordForMissingCrossNegatives = action.payload;
    },
    setSTMissingCrossNegatives: (state, action) => {
      state.stMissingCrossNegatives = action.payload;
    },
    setSelectedRowsForMissingCrossNegatives: (state, action) => {
      state.selectedRowsForMissingCrossNegatives = action.payload;
    },
    setToggledNegativesForMissingCrossNegatives: (state, action) => {
      state.toggledNegativesForMissingCrossNegatives = action.payload;
    },
    setIsOpenModalOfOtherNonNegativeAdgroups: (state, action) => {
      state.isOpenModalOfOtherNonNegativeAdgroups = action.payload;
    },
    setOtherNonNegativeAdgroupsForMissingCrossNegatives: (state, action) => {
      state.otherNonNegativeAdgroupsForMissingCrossNegatives = action.payload;
    },
    setIsDefinitionModalOpenForMissingCrossNegatives: (state, action) => {
      state.isDefinitionModalOpenForMissingCrossNegatives = action.payload;
    },
    setDefinitionModalSourceForMissingCrossNegatives: (state, action) => {
      state.definitionModalSourceForMissingCrossNegatives = action.payload;
    },

    setSelectedSearchTermForContradictingSTDefinition: (state, action) => {
      state.selectedSearchTermForContradictingSTDefinition = action.payload;
    },
    setSelectedCampaignForContradictingSTDefinition: (state, action) => {
      state.selectedCampaignForContradictingSTDefinition = action.payload;
    },
    setSelectedAdGroupForContradictingSTDefinition: (state, action) => {
      state.selectedAdGroupForContradictingSTDefinition = action.payload;
    },
    setSelectedKeywordForContradictingSTDefinition: (state, action) => {
      state.selectedKeywordForContradictingSTDefinition = action.payload;
    },
    setContradictingSTDefinition: (state, action) => {
      state.contradictingSTDefinition = action.payload;
    },
    setSelectedRowsForContradictingSTDefinition: (state, action) => {
      state.selectedRowsForContradictingSTDefinition = action.payload;
    },
    setToggledNegativesForContradictingSTDefinition: (state, action) => {
      state.toggledNegativesForContradictingSTDefinition = action.payload;
    },
    setIsDefinitionModalOpenForContradictingST: (state, action) => {
      state.isDefinitionModalOpenForContradictingST = action.payload;
    },
    setDefinitionModalSourceForContradictingST: (state, action) => {
      state.definitionModalSourceForContradictingST = action.payload;
    },
    setConfirmLoaderForContradictingSTDefinition: (state, action) => {
      state.confirmLoaderForContradictingSTDefinition = action.payload;
    },
    setSelectedSearchTermForIdenticalToExactKeyword: (state, action) => {
      state.selectedSearchTermForIdenticalToExactKeyword = action.payload;
    },
    setSelectedCampaignForIdenticalToExactKeyword: (state, action) => {
      state.selectedCampaignForIdenticalToExactKeyword = action.payload;
    },
    setSelectedAdGroupForIdenticalToExactKeyword: (state, action) => {
      state.selectedAdGroupForIdenticalToExactKeyword = action.payload;
    },
    setSelectedKeywordForIdenticalToExactKeyword: (state, action) => {
      state.selectedKeywordForIdenticalToExactKeyword = action.payload;
    },
    setSTIdenticalToExactKeyword: (state, action) => {
      state.stIdenticalToExactKeyword = action.payload;
    },
    setSelectedRowsForIdenticalToExactKeyword: (state, action) => {
      state.selectedRowsForIdenticalToExactKeyword = action.payload;
    },
    setToggledNegativesForIdenticalToExactKeyword: (state, action) => {
      state.toggledNegativesForIdenticalToExactKeyword = action.payload;
    },
    setIsDefinitionModalOpenForIdenticalToExactKeyword: (state, action) => {
      state.isDefinitionModalOpenForIdenticalToExactKeyword = action.payload;
    },
    setDefinitionModalSourceForIdenticalToExactKeyword: (state, action) => {
      state.definitionModalSourceForIdenticalToExactKeyword = action.payload;
    },
    setIsOpenModalOfAdgroupsForIdenticalToExactKeyword: (state, action) => {
      state.isOpenModalOfAdgroupsForIdenticalToExactKeyword = action.payload;
    },
    setOtherNonNegativeAdgroupsForIdenticalToExactKeyword: (state, action) => {
      state.otherNonNegativeAdgroupsForIdenticalToExactKeyword = action.payload;
    },

    setSelectedSearchTermForCapturedByMultipleKeywords: (state, action) => {
      state.selectedSearchTermForCapturedByMultipleKeywords = action.payload;
    },
    setSelectedCampaignForCapturedByMultipleKeywords: (state, action) => {
      state.selectedCampaignForCapturedByMultipleKeywords = action.payload; // filter reset
    },
    setSelectedAdGroupForCapturedByMultipleKeywords: (state, action) => {
      state.selectedAdGroupForCapturedByMultipleKeywords = action.payload; // filter reset
    },
    setSelectedKeywordForCapturedByMultipleKeywords: (state, action) => {
      state.selectedKeywordForCapturedByMultipleKeywords = action.payload; // filter reset
    },
    setCapturedByMultipleKeywords: (state, action) => {
      state.capturedByMultipleKeywords = action.payload; // Search Terms captured by multiple keywords
    },
    setSelectedRowsForCapturedByMultipleKeywords: (state, action) => {
      state.selectedRowsForCapturedByMultipleKeywords = action.payload; // selected rows in the table
    },
    setSelectedDefinitionsForCapturedByMultipleKeywords: (state, action) => {
      state.selectedDefinitionsForCapturedByMultipleKeywords = action.payload; // selected definitions for each row
    },
    setIsDefinitionModalOpenForCapturedByMultipleKeywords: (state, action) => {
      state.isDefinitionModalOpenForCapturedByMultipleKeywords = action.payload;
    },
    setDefinitionModalSourceForCapturedByMultipleKeywords: (state, action) => {
      state.definitionModalSourceForCapturedByMultipleKeywords = action.payload;
    },

    setDefinitionModalTypeForCapturedByMultipleKeywords: (state, action) => {
      state.definitionModalTypeForCapturedByMultipleKeywords = action.payload;
    },
    setIsOpenOtherKeywordDialogForCapturedByMultipleKeywords: (
      state,
      action
    ) => {
      state.isOpenOtherKeywordDialogForCapturedByMultipleKeywords =
        action.payload; // Other Keyword dialog open state
    },
    setOtherKeywordsForCapturedByMultipleKeywords: (state, action) => {
      state.otherKeywordsForCapturedByMultipleKeywords = action.payload; // other keywords modal data
    },

    //===: Reset Search Terms with Performance, Without Classification :===//
    resetPerformanceUnclassifiedSearchTerm: (state) => {
      state.selectedSearchTermForUnclassifiedST = ""; // filter reset
      state.selectedCampaignForUnclassifiedST = []; // filter reset
      state.selectedAdGroupForUnclassifiedST = []; // filter reset
      state.selectedKeywordForUnclassifiedST = []; // filter reset
      state.selectedRowsForUnclassifiedST = []; // selected rows reset
      state.selectedDefinitionsForUnclassifiedST = {}; // reset selected definitions for each row
      state.isDefinitionModalOpenForUnclassifiedST = false; // reset modal open state for unclassified ST
      state.definitionModalSourceForUnclassifiedST = ""; // reset modal source (headerIcon or saveButton) for unclassified ST
      state.definitionModalTypeForUnclassifiedST = ""; // reset modal type (Exclusive, Allowed, Negative) for unclassified ST
      state.isOpenOtherKeywordDialogSTOUnclassified = false; // reset Other Keyword Dialog open state for unclassified ST
      state.otherKeywordsForUnclassifiedST = []; // reset Other Keywords Modal data for unclassified ST
      state.otherKeywordRelatedToSearchTerm = "";
    },

    //===: Reset Search Terms Missing Cross Negatives :===//
    resetMissingCrossNegativesSearchTerm: (state) => {
      state.selectedSearchTermForMissingCrossNegatives = ""; // filter reset
      state.selectedCampaignForMissingCrossNegatives = []; // filter reset
      state.selectedAdGroupForMissingCrossNegatives = []; // filter reset
      state.selectedKeywordForMissingCrossNegatives = []; // filter reset
      state.selectedRowsForMissingCrossNegatives = []; // selected rows reset
      state.toggledNegativesForMissingCrossNegatives = []; // reset selected definitions for each row
      state.isDefinitionModalOpenForMissingCrossNegatives = false; // reset modal open state for Missing Cross Negatives
      state.definitionModalSourceForMissingCrossNegatives = ""; // reset modal source (headerIcon or saveButton) for Missing Cross Negatives
      state.isOpenModalOfOtherNonNegativeAdgroups = false; // reset Other Non-Negative Adgroups Modal open state for Missing Cross Negatives
      state.otherNonNegativeAdgroupsForMissingCrossNegatives = []; // reset Other Non-Negative Adgroups Modal data for Missing Cross Negatives
    },

    //===: Reset STO search terms Contradicting ST Definition :===//
    resetContradictingSTDefinitionSearchTerm: (state) => {
      state.selectedSearchTermForContradictingSTDefinition = ""; // filter reset
      state.selectedCampaignForContradictingSTDefinition = []; // filter reset
      state.selectedAdGroupForContradictingSTDefinition = []; // filter reset
      state.selectedKeywordForContradictingSTDefinition = []; // filter reset
      state.selectedRowsForContradictingSTDefinition = []; // selected rows reset
      state.toggledNegativesForContradictingSTDefinition = []; // reset Toggled definitions for each row

      state.isDefinitionModalOpenForContradictingST = false; // reset modal open state for Contradicting ST
      state.definitionModalSourceForContradictingST = ""; // reset modal source (headerIcon or saveButton) for Missing Cross Negatives
    },
    //===: Reset STO search term tab :===//
    resetIdenticalToExactKeyword: (state) => {
      state.selectedSearchTermForIdenticalToExactKeyword = ""; // filter reset
      state.selectedCampaignForIdenticalToExactKeyword = []; // filter reset
      state.selectedAdGroupForIdenticalToExactKeyword = []; // filter reset
      state.selectedKeywordForIdenticalToExactKeyword = []; // filter reset
      state.selectedRowsForIdenticalToExactKeyword = []; // selected rows reset
      state.toggledNegativesForIdenticalToExactKeyword = []; // reset Toggled definitions for each row
      state.isDefinitionModalOpenForIdenticalToExactKeyword = false; // reset modal open state for Identical To Exact Keyword
      state.definitionModalSourceForIdenticalToExactKeyword = ""; // reset modal source (headerIcon or saveButton) for Identical To Exact Keyword
      state.isOpenModalOfAdgroupsForIdenticalToExactKeyword = false; // reset Other Non-Negative Adgroups Modal open state for Identical To Exact Keyword
      state.otherNonNegativeAdgroupsForIdenticalToExactKeyword = []; // reset Other Non-Negative Adgroups Modal data for Identical To Exact Keyword
    },

    //===: Reset STO search terms Captured By Multiple Keywords :===//
    resetCapturedByMultipleKeywordsSearchTerm: (state) => {
      state.selectedSearchTermForCapturedByMultipleKeywords = ""; // filter reset
      state.selectedCampaignForCapturedByMultipleKeywords = []; // filter reset
      state.selectedAdGroupForCapturedByMultipleKeywords = []; // filter reset
      state.selectedKeywordForCapturedByMultipleKeywords = []; // filter reset
      state.selectedRowsForCapturedByMultipleKeywords = []; // selected rows reset
      state.selectedDefinitionsForCapturedByMultipleKeywords = {}; // reset selected definitions for each row
      state.isDefinitionModalOpenForCapturedByMultipleKeywords = false;
      state.definitionModalSourceForCapturedByMultipleKeywords = "";
      state.definitionModalTypeForCapturedByMultipleKeywords = ""; // reset modal type (Exclusive, Negative)
      state.isOpenOtherKeywordDialogForCapturedByMultipleKeywords = false; // reset Other Keyword dialog open state
      state.otherKeywordsForCapturedByMultipleKeywords = []; // reset other keywords modal data
    },

    resetStateOfSearchTermTab: () => initialState, // reset everything for STO search term tab
  },
});

export const {
  setSelectedSearchTermForUnclassifiedST,
  setSelectedCampaignForUnclassifiedST,
  setSelectedAdGroupForUnclassifiedST,
  setSelectedKeywordForUnclassifiedST,
  setSTWithPerformanceUnClassified,
  setSearchTermTabLoader,
  setIsSearchTermTabDataFetched,
  setSelectedRowsForUnclassifiedST,
  setSelectedDefinitionsForUnclassifiedST,
  setIsDefinitionModalOpenForUnclassifiedST,
  setDefinitionModalSourceForUnclassifiedST,
  setDefinitionModalTypeForUnclassifiedST,
  setIsOpenOtherKeywordDialogSTOUnclassified,
  setOtherKeywordsForUnclassifiedST,
  setOtherKeywordRelatedToSearchTerm,
  setConfirmLoaderSTControl,

  setSelectedSearchTermForMissingCrossNegatives,
  setSelectedCampaignForMissingCrossNegatives,
  setSelectedAdGroupForMissingCrossNegatives,
  setSelectedKeywordForMissingCrossNegatives,
  setSTMissingCrossNegatives,
  setSelectedRowsForMissingCrossNegatives,
  setToggledNegativesForMissingCrossNegatives,
  setIsDefinitionModalOpenForMissingCrossNegatives,
  setDefinitionModalSourceForMissingCrossNegatives,
  setIsOpenModalOfOtherNonNegativeAdgroups,
  setOtherNonNegativeAdgroupsForMissingCrossNegatives,

  setSelectedSearchTermForContradictingSTDefinition,
  setSelectedCampaignForContradictingSTDefinition,
  setSelectedAdGroupForContradictingSTDefinition,
  setSelectedKeywordForContradictingSTDefinition,
  setContradictingSTDefinition,
  setSelectedRowsForContradictingSTDefinition,
  setToggledNegativesForContradictingSTDefinition,
  setIsDefinitionModalOpenForContradictingST,
  setDefinitionModalSourceForContradictingST,
  setConfirmLoaderForContradictingSTDefinition,

  setSelectedSearchTermForIdenticalToExactKeyword,
  setSelectedCampaignForIdenticalToExactKeyword,
  setSelectedAdGroupForIdenticalToExactKeyword,
  setSelectedKeywordForIdenticalToExactKeyword,
  setSTIdenticalToExactKeyword,
  setSelectedRowsForIdenticalToExactKeyword,
  setToggledNegativesForIdenticalToExactKeyword,
  setIsDefinitionModalOpenForIdenticalToExactKeyword,
  setDefinitionModalSourceForIdenticalToExactKeyword,
  setIsOpenModalOfAdgroupsForIdenticalToExactKeyword,
  setOtherNonNegativeAdgroupsForIdenticalToExactKeyword,

  setSelectedSearchTermForCapturedByMultipleKeywords,
  setSelectedCampaignForCapturedByMultipleKeywords,
  setSelectedAdGroupForCapturedByMultipleKeywords,
  setSelectedKeywordForCapturedByMultipleKeywords,
  setCapturedByMultipleKeywords,
  setSelectedRowsForCapturedByMultipleKeywords,
  setSelectedDefinitionsForCapturedByMultipleKeywords,
  setIsDefinitionModalOpenForCapturedByMultipleKeywords,
  setDefinitionModalSourceForCapturedByMultipleKeywords,
  setDefinitionModalTypeForCapturedByMultipleKeywords,
  setIsOpenOtherKeywordDialogForCapturedByMultipleKeywords,
  setOtherKeywordsForCapturedByMultipleKeywords,

  resetPerformanceUnclassifiedSearchTerm, // Reset Search Terms with Performance, Without Classification
  resetMissingCrossNegativesSearchTerm, // Reset Search Terms Missing Cross Negatives
  resetContradictingSTDefinitionSearchTerm, // Reset STO search terms Contradicting ST Definition
  resetIdenticalToExactKeyword, // Reset STO search terms Identical To Exact Keyword
  resetCapturedByMultipleKeywordsSearchTerm, // Reset STO search terms Captured By Multiple Keywords
  resetStateOfSearchTermTab, // Reset STO search term tab
} = searchTermTabSlice.actions;
export default searchTermTabSlice.reducer;
